import { render, staticRenderFns } from "./ImportacionPadronIngresosBruto.vue?vue&type=template&id=e0b742be"
import script from "./ImportacionPadronIngresosBruto.vue?vue&type=script&lang=js"
export * from "./ImportacionPadronIngresosBruto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports